/* globals Attachments */
import 'packery/dist/packery.pkgd'
import 'jquery-countdown'

window['attachment_relations#index'] = function () {
  Attachments.init('.file-item')
  Attachments.auditableCountdown()

  $('.attachments-search .dropdown-menu').click(function (e) {
    e.stopPropagation()
  })
}
